module.exports = __webpack_public_path__ + "img/ITS_Kompetent_Logo.891ef604.svg";